module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smart_Cameras.03052027.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smart_Cameras.svg
// module id = 3550
// module chunks = 0